// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Broadcaster\EventBroadcaster & App\Broadcaster\Dto

import type { CustomerPackageApiResponse } from './customerPackage.gen';
import type { NotificationApiResponse } from './notification.gen';

export enum AppEvent {
	ACTIVITY_CREATED = 'activity_created',
	ACTIVITY_DELETED = 'activity_deleted',
	ACTIVITY_UPDATED = 'activity_updated',
	AREA_CREATED = 'area_created',
	AREA_DELETED = 'area_deleted',
	AREA_UPDATED = 'area_updated',
	BILLING_INVOICE_CANCELED = 'billing_invoice_canceled',
	BILLING_INVOICE_CREATED = 'billing_invoice_created',
	BILLING_INVOICE_PAID = 'billing_invoice_paid',
	BILLING_INVOICE_UNPAID = 'billing_invoice_unpaid',
	BILLING_INVOICE_UPDATED = 'billing_invoice_updated',
	BILLING_MONTHLY_FEE = 'billing_monthly_fee',
	BILLING_PAYMENT_DISPUTE_RECOVERED = 'billing_payment_dispute_recovered',
	BILLING_PAYMENT_FAILED = 'billing_payment_failed',
	BILLING_PAYMENT_PAID = 'billing_payment_paid',
	BILLING_PAYMENT_RETRY = 'billing_payment_retry',
	BILLING_PAYMENT_SUCCESS = 'billing_payment_success',
	BILLING_PLAN_SANCTION_REACTIVATION = 'billing_plan_sanction_reactivation',
	BILLING_PLAN_SANCTION_SUSPENSION = 'billing_plan_sanction_suspension',
	BILLING_PLAN_SANCTION_WARNING = 'billing_plan_sanction_warning',
	BILLING_SUBSCRIPTION_GENERATE = 'billing_subscription_generate',
	BLOCKING_PERIODS_REFRESHED = 'blocking_periods_refreshed',
	BLOCKING_PERIOD_CREATED = 'blocking_period_created',
	BLOCKING_PERIOD_DELETED = 'blocking_period_deleted',
	BLOCKING_PERIOD_UPDATED = 'blocking_period_updated',
	BOOKABLE_GIFTCARD_CREATED = 'bookable_giftcard_created',
	BOOKABLE_GIFTCARD_DELETED = 'bookable_giftcard_deleted',
	BOOKABLE_GIFTCARD_UPDATED = 'bookable_giftcard_updated',
	BOOKING_BOOKED = 'booking_booked',
	BOOKING_CANCELED = 'booking_canceled',
	BOOKING_CONFIRMED = 'booking_confirmed',
	BOOKING_CREATED = 'booking_created',
	BOOKING_EVENT_CREATED = 'booking_event_created',
	BOOKING_EVENT_DELETED = 'booking_event_deleted',
	BOOKING_EVENT_SCHEDULE = 'booking_event_schedule',
	BOOKING_EVENT_UPDATED = 'booking_event_updated',
	BOOKING_EXPIRED = 'booking_expired',
	BOOKING_EXPORT = 'booking_export',
	BOOKING_GUARANTEE_ASKED = 'booking_guarantee_asked',
	BOOKING_GUARANTEE_AUTHORIZED = 'booking_guarantee_authorized',
	BOOKING_GUARANTEE_CANCELED = 'booking_guarantee_canceled',
	BOOKING_GUARANTEE_FAILED = 'booking_guarantee_failed',
	BOOKING_GUARANTEE_PROCESS = 'booking_guarantee_process',
	BOOKING_INTENT = 'booking_intent',
	BOOKING_INTENT_EXPIRED = 'booking_intent_expired',
	BOOKING_LEFT = 'booking_left',
	BOOKING_NO_SHOW = 'booking_no_show',
	BOOKING_PAYMENT_TRANSACTION_CANCELED = 'booking_payment_transaction_canceled',
	BOOKING_PAYMENT_TRANSACTION_CONFIRMED = 'booking_payment_transaction_confirmed',
	BOOKING_PAYMENT_TRANSACTION_FAILED = 'booking_payment_transaction_failed',
	BOOKING_PAYMENT_TRANSACTION_NEW = 'booking_payment_transaction_new',
	BOOKING_PAYMENT_TRANSACTION_REFUNDED = 'booking_payment_transaction_refunded',
	BOOKING_RECONFIRMED = 'booking_reconfirmed',
	BOOKING_REVIEW_ANSWERED = 'booking_review_answered',
	BOOKING_REVIEW_REPLIED = 'booking_review_replied',
	BOOKING_REVIEW_UNREAD_COUNT_UPDATED = 'booking_review_unread_count_updated',
	BOOKING_SPLIT_PAYMENT_DEADLINE_EXPIRED = 'booking_split_payment_deadline_expired',
	BOOKING_SUMMARY_EMAIL_REQUESTED = 'booking_summary_email_requested',
	BOOKING_TO_BE_CONFIRMED = 'booking_to_be_confirmed',
	BOOKING_TO_BE_PAYED = 'booking_to_be_payed',
	BOOKING_TO_BE_RECONFIRMED = 'booking_to_be_reconfirmed',
	BOOKING_UPDATED = 'booking_updated',
	BUSINESS_CONTRACT_UPDATED = 'business_contract_updated',
	BUSINESS_CREATED = 'business_created',
	BUSINESS_EMAIL_SETTINGS_UPDATED = 'business_email_settings_updated',
	BUSINESS_FEATURE_FLIPPING_UPDATED = 'business_feature_flipping_updated',
	BUSINESS_SMS_CREDITS_REFILL_REQUEST_AUTO = 'business_sms_credits_refill_request_auto',
	BUSINESS_SMS_CREDITS_REFILL_REQUEST_MANUAL = 'business_sms_credits_refill_request_manual',
	BUSINESS_SMS_CREDITS_UPDATED = 'business_sms_credits_updated',
	BUSINESS_SMS_SETTINGS_CREATED = 'business_sms_settings_created',
	BUSINESS_SMS_SETTINGS_UPDATED = 'business_sms_settings_updated',
	BUSINESS_UI_UPDATED = 'business_ui_updated',
	BUSINESS_UPDATED = 'business_updated',
	BUSINESS_VAT_NUMBER_UPDATED = 'business_vat_number_updated',
	BUSINESS_WIDGET_CREATED = 'business_widget_created',
	BUSINESS_WIDGET_UPDATED = 'business_widget_updated',
	CUSTOMER_CREATED = 'customer_created',
	CUSTOMER_DELETED = 'customer_deleted',
	CUSTOMER_PACKAGE_CREATED = 'customer_package_created',
	CUSTOMER_PACKAGE_DELETED = 'customer_package_deleted',
	CUSTOMER_PACKAGE_REASSIGNED = 'customer_package_reassigned',
	CUSTOMER_PACKAGE_UPDATED = 'customer_package_updated',
	CUSTOMER_UPDATED = 'customer_updated',
	CUSTOM_FIELD_CREATED = 'custom_field_created',
	CUSTOM_FIELD_DELETED = 'custom_field_deleted',
	CUSTOM_FIELD_UPDATED = 'custom_field_updated',
	EXPORT_READY = 'export_ready',
	GIFTCARD_CONSUMED = 'giftcard_consumed',
	GIFTCARD_CREATED = 'giftcard_created',
	GIFTCARD_DELETED = 'giftcard_deleted',
	GIFTCARD_ORDER_CREATED = 'giftcard_order_created',
	GIFTCARD_ORDER_PAYED = 'giftcard_order_payed',
	GIFTCARD_RECREDITED = 'giftcard_recredited',
	GOOGLE_CALENDAR_TOKEN_RENEW = 'google_calendar_token_renew',
	GOOGLE_RESERVE_AUTOMATIC_DISABLED = 'google_reserve_automatic_disabled',
	GOOGLE_RESERVE_DISABLED = 'google_reserve_disabled',
	GOOGLE_RESERVE_ENABLED = 'google_reserve_enabled',
	MEMO_CREATED = 'memo_created',
	MEMO_DELETED = 'memo_deleted',
	MEMO_UPDATED = 'memo_updated',
	NOTIFICATION_ALL_READ = 'notification_all_read',
	NOTIFICATION_CREATED = 'notification_created',
	NOTIFICATION_READ = 'notification_read',
	NOTIFICATION_UNREAD = 'notification_unread',
	OFFER_COLLECTION_CREATED = 'offer_collection_created',
	OFFER_COLLECTION_DELETED = 'offer_collection_deleted',
	OFFER_COLLECTION_UPDATED = 'offer_collection_updated',
	OFFER_CREATED = 'offer_created',
	OFFER_DELETED = 'offer_deleted',
	OFFER_PRICE_UPDATED = 'offer_price_updated',
	OFFER_PUBLISHED = 'offer_published',
	OFFER_UNPUBLISHED = 'offer_unpublished',
	OFFER_UPDATED = 'offer_updated',
	OPENING_HOUR_CREATED = 'opening_hour_created',
	OPENING_HOUR_DELETED = 'opening_hour_deleted',
	OPENING_HOUR_EXCEPTION_CREATED = 'opening_hour_exception_created',
	OPENING_HOUR_EXCEPTION_DELETED = 'opening_hour_exception_deleted',
	OPENING_HOUR_EXCEPTION_UPDATED = 'opening_hour_exception_updated',
	OPENING_HOUR_UPDATED = 'opening_hour_updated',
	PACKAGE_CREATED = 'package_created',
	PACKAGE_DELETED = 'package_deleted',
	PACKAGE_UPDATED = 'package_updated',
	PAYMENT_METHOD_UPDATED = 'payment_method_updated',
	PAYMENT_TRANSACTION_FAILED = 'payment_transaction_failed',
	PAYMENT_TRANSACTION_SUCCESS = 'payment_transaction_success',
	PRODUCT_CREATED = 'product_created',
	PRODUCT_DELETED = 'product_deleted',
	PRODUCT_UPDATED = 'product_updated',
	PROMO_CODE_CREATED = 'promo_code_created',
	PROMO_CODE_DELETED = 'promo_code_deleted',
	PROMO_CODE_UPDATED = 'promo_code_updated',
	QR_CODE_SCANNED = 'qr_code_scanned',
	SESSION_CREATED = 'session_created',
	SESSION_DELETED = 'session_deleted',
	SESSION_INSTANCE_CREATED = 'session_instance_created',
	SESSION_INSTANCE_DELETED = 'session_instance_deleted',
	SESSION_UPDATED = 'session_updated',
	SUBSCRIPTION_CANCELED = 'subscription_canceled',
	SUBSCRIPTION_REACTIVATED = 'subscription_reactivated',
	SUBSCRIPTION_SELECTED = 'subscription_selected',
	TAG_CREATED = 'tag_created',
	TAG_DELETED = 'tag_deleted',
	TEST_EVENT = 'test_event',
	USER_CREATED = 'user_created',
	USER_DELETED = 'user_deleted',
	USER_DO_NOT_DISTURB_UPDATED = 'user_do_not_disturb_updated',
	USER_FORGOTTEN_PASSWORD = 'user_forgotten_password',
	USER_FORGOTTEN_PASSWORD_RECOVERED = 'user_forgotten_password_recovered',
	USER_PASSWORD_UPDATED = 'user_password_updated',
	USER_UPDATED = 'user_updated',
	VOUCHER_APPLIED = 'voucher_applied',
}

export type AppEventPayloadMap = {
	[AppEvent.ACTIVITY_CREATED]: {
		activity_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.ACTIVITY_DELETED]: {
		activity_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.ACTIVITY_UPDATED]: {
		activity_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.AREA_CREATED]: {
		area_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.AREA_DELETED]: {
		area_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.AREA_UPDATED]: {
		area_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BILLING_INVOICE_CANCELED]: {
		business_id: string;
		invoice_id: number;
	};
	[AppEvent.BILLING_INVOICE_CREATED]: {
		business_id: string;
		invoice_id: number;
	};
	[AppEvent.BILLING_INVOICE_PAID]: {
		business_id: string;
		invoice_id: number;
	};
	[AppEvent.BILLING_INVOICE_UNPAID]: {
		business_id: string;
		invoice_id: number;
	};
	[AppEvent.BILLING_INVOICE_UPDATED]: {
		business_id: string;
		invoice_id: number;
	};
	[AppEvent.BILLING_MONTHLY_FEE]: {
		business_id: string;
		lock: string | null;
	};
	[AppEvent.BILLING_PAYMENT_DISPUTE_RECOVERED]: {
		business_id: string;
		billing_payment_id: number;
	};
	[AppEvent.BILLING_PAYMENT_FAILED]: {
		business_id: string;
		billing_payment_id: number;
	};
	[AppEvent.BILLING_PAYMENT_PAID]: {
		business_id: string;
		billing_payment_id: number;
	};
	[AppEvent.BILLING_PAYMENT_RETRY]: {
		business_id: string;
	};
	[AppEvent.BILLING_PAYMENT_SUCCESS]: {
		business_id: string;
		billing_payment_id: number;
	};
	[AppEvent.BILLING_PLAN_SANCTION_REACTIVATION]: {
		business_id: string;
	};
	[AppEvent.BILLING_PLAN_SANCTION_SUSPENSION]: {
		business_id: string;
		reason: string;
	};
	[AppEvent.BILLING_PLAN_SANCTION_WARNING]: {
		business_id: string;
		reason: string;
	};
	[AppEvent.BILLING_SUBSCRIPTION_GENERATE]: {
		business_id: string;
		lock: string | null;
	};
	[AppEvent.BLOCKING_PERIODS_REFRESHED]: {
		business_id: string;
	};
	[AppEvent.BLOCKING_PERIOD_CREATED]: {
		blocking_period_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BLOCKING_PERIOD_DELETED]: {
		blocking_period_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BLOCKING_PERIOD_UPDATED]: {
		blocking_period_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKABLE_GIFTCARD_CREATED]: {
		bookable_giftcard_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKABLE_GIFTCARD_DELETED]: {
		bookable_giftcard_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKABLE_GIFTCARD_UPDATED]: {
		bookable_giftcard_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKING_BOOKED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_CANCELED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_CONFIRMED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_CREATED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_customer_id: string | null;
	};
	[AppEvent.BOOKING_EVENT_CREATED]: {
		booking_event_id: string;
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKING_EVENT_DELETED]: {
		booking_event_id: string;
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKING_EVENT_SCHEDULE]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_EVENT_UPDATED]: {
		booking_event_id: string;
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKING_EXPIRED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_EXPORT]: {
		startDate: string;
		endDate: string;
		business_id: string;
		user_id: string;
	};
	[AppEvent.BOOKING_GUARANTEE_ASKED]: {
		booking_id: string;
		guarantee_amount: number;
		email: string | null;
	};
	[AppEvent.BOOKING_GUARANTEE_AUTHORIZED]: {
		booking_id: string;
		message: string | null;
	};
	[AppEvent.BOOKING_GUARANTEE_CANCELED]: {
		booking_id: string;
		guarantee_id: number;
	};
	[AppEvent.BOOKING_GUARANTEE_FAILED]: {
		booking_id: string;
		message: string | null;
	};
	[AppEvent.BOOKING_GUARANTEE_PROCESS]: {
		booking_id: string;
		message: string | null;
	};
	[AppEvent.BOOKING_INTENT]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_INTENT_EXPIRED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_LEFT]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_NO_SHOW]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_PAYMENT_TRANSACTION_CANCELED]: {
		payment_id: string;
		booking_id: string;
		changes: Record<string, unknown>;
		is_initial_booking_payment: boolean;
	};
	[AppEvent.BOOKING_PAYMENT_TRANSACTION_CONFIRMED]: {
		payment_id: string;
		booking_id: string;
		changes: Record<string, unknown>;
		is_initial_booking_payment: boolean;
	};
	[AppEvent.BOOKING_PAYMENT_TRANSACTION_FAILED]: {
		payment_id: string;
		booking_id: string;
		changes: Record<string, unknown>;
		is_initial_booking_payment: boolean;
	};
	[AppEvent.BOOKING_PAYMENT_TRANSACTION_NEW]: {
		payment_id: string;
		booking_id: string;
		changes: Record<string, unknown>;
		is_initial_booking_payment: boolean;
	};
	[AppEvent.BOOKING_PAYMENT_TRANSACTION_REFUNDED]: {
		payment_id: string;
		booking_id: string;
		amount: number;
		refunded_at: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BOOKING_RECONFIRMED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_REVIEW_ANSWERED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_REVIEW_REPLIED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_REVIEW_UNREAD_COUNT_UPDATED]: {
		business_id: string;
		count: number;
	};
	[AppEvent.BOOKING_SPLIT_PAYMENT_DEADLINE_EXPIRED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_SUMMARY_EMAIL_REQUESTED]: {
		booking_id: string;
	};
	[AppEvent.BOOKING_TO_BE_CONFIRMED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_TO_BE_PAYED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_TO_BE_RECONFIRMED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_status: string | null;
	};
	[AppEvent.BOOKING_UPDATED]: {
		booking_id: string;
		changes: Record<string, unknown>;
		previous_customer_id: string | null;
	};
	[AppEvent.BUSINESS_CONTRACT_UPDATED]: {
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BUSINESS_CREATED]: {
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BUSINESS_EMAIL_SETTINGS_UPDATED]: {
		business_id: string;
	};
	[AppEvent.BUSINESS_FEATURE_FLIPPING_UPDATED]: {
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BUSINESS_SMS_CREDITS_REFILL_REQUEST_AUTO]: {
		business_id: string;
		credit_amount: number;
		hash: string;
	};
	[AppEvent.BUSINESS_SMS_CREDITS_REFILL_REQUEST_MANUAL]: {
		business_id: string;
		credit_amount: number;
		hash: string;
	};
	[AppEvent.BUSINESS_SMS_CREDITS_UPDATED]: {
		business_id: string;
		credits: number;
		remainingCredits: number;
		admin: boolean;
	};
	[AppEvent.BUSINESS_SMS_SETTINGS_CREATED]: {
		business_id: string;
	};
	[AppEvent.BUSINESS_SMS_SETTINGS_UPDATED]: {
		business_id: string;
	};
	[AppEvent.BUSINESS_UI_UPDATED]: {
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BUSINESS_UPDATED]: {
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BUSINESS_VAT_NUMBER_UPDATED]: {
		business_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.BUSINESS_WIDGET_CREATED]: {
		business_id: string;
	};
	[AppEvent.BUSINESS_WIDGET_UPDATED]: {
		business_id: string;
	};
	[AppEvent.CUSTOMER_CREATED]: {
		customer_id: string;
		changes: Record<string, unknown>;
		source: string | null;
	};
	[AppEvent.CUSTOMER_DELETED]: {
		customer_id: string;
		changes: Record<string, unknown>;
		source: string | null;
	};
	[AppEvent.CUSTOMER_PACKAGE_CREATED]: {
		customer_package_id: string;
		customer_package: CustomerPackageApiResponse;
		business_id: string | null;
		payment_id: string | null;
	};
	[AppEvent.CUSTOMER_PACKAGE_DELETED]: {
		customer_package_id: string;
		customer_package: CustomerPackageApiResponse;
		business_id: string | null;
		payment_id: string | null;
	};
	[AppEvent.CUSTOMER_PACKAGE_REASSIGNED]: {
		customer_package_id: string;
		customer_package: CustomerPackageApiResponse;
		business_id: string | null;
		payment_id: string | null;
	};
	[AppEvent.CUSTOMER_PACKAGE_UPDATED]: {
		customer_package_id: string;
		customer_package: CustomerPackageApiResponse;
		business_id: string | null;
		payment_id: string | null;
	};
	[AppEvent.CUSTOMER_UPDATED]: {
		customer_id: string;
		changes: Record<string, unknown>;
		source: string | null;
	};
	[AppEvent.CUSTOM_FIELD_CREATED]: {
		custom_field_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.CUSTOM_FIELD_DELETED]: {
		custom_field_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.CUSTOM_FIELD_UPDATED]: {
		custom_field_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.EXPORT_READY]: {
		exportTitle: string;
		url: string;
		uploadAssetId: number;
		expiresAt: string | null;
	};
	[AppEvent.GIFTCARD_CONSUMED]: {
		giftcard_id: string;
		amount: number;
		code: string;
	};
	[AppEvent.GIFTCARD_CREATED]: {
		giftcard_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.GIFTCARD_DELETED]: {
		giftcard_id: string;
	};
	[AppEvent.GIFTCARD_ORDER_CREATED]: {
		giftcard_order_id: number;
		business_id: string;
	};
	[AppEvent.GIFTCARD_ORDER_PAYED]: {
		giftcard_order_id: number;
		payment_id: string;
		business_id: string;
		amount: number;
	};
	[AppEvent.GIFTCARD_RECREDITED]: {
		giftcard_id: string;
		amount: number;
		code: string;
		booking_id: string | null;
	};
	[AppEvent.GOOGLE_CALENDAR_TOKEN_RENEW]: {
		google_calendar_id: number;
		business_id: string;
	};
	[AppEvent.GOOGLE_RESERVE_AUTOMATIC_DISABLED]: {
		business_id: string;
		disabled_at: string | null;
	};
	[AppEvent.GOOGLE_RESERVE_DISABLED]: {
		business_id: string;
		disabled_at: string | null;
	};
	[AppEvent.GOOGLE_RESERVE_ENABLED]: {
		business_id: string;
		disabled_at: string | null;
	};
	[AppEvent.MEMO_CREATED]: {
		memo_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.MEMO_DELETED]: {
		memo_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.MEMO_UPDATED]: {
		memo_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.NOTIFICATION_ALL_READ]: {};
	[AppEvent.NOTIFICATION_CREATED]: {
		notification_id: number;
		notification: NotificationApiResponse;
	};
	[AppEvent.NOTIFICATION_READ]: {
		notification_id: number;
	};
	[AppEvent.NOTIFICATION_UNREAD]: {
		notification_id: number;
	};
	[AppEvent.OFFER_COLLECTION_CREATED]: {
		offer_collection_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.OFFER_COLLECTION_DELETED]: {
		offer_collection_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.OFFER_COLLECTION_UPDATED]: {
		offer_collection_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.OFFER_CREATED]: {
		offer_id: string;
		changes: Record<string, unknown>;
		duplicate_of: string | null;
	};
	[AppEvent.OFFER_DELETED]: {
		offer_id: string;
		changes: Record<string, unknown>;
		duplicate_of: string | null;
	};
	[AppEvent.OFFER_PRICE_UPDATED]: {
		offer_id: string;
		changes: Record<string, unknown>;
		duplicate_of: string | null;
	};
	[AppEvent.OFFER_PUBLISHED]: {
		offer_id: string;
		changes: Record<string, unknown>;
		duplicate_of: string | null;
	};
	[AppEvent.OFFER_UNPUBLISHED]: {
		offer_id: string;
		changes: Record<string, unknown>;
		duplicate_of: string | null;
	};
	[AppEvent.OFFER_UPDATED]: {
		offer_id: string;
		changes: Record<string, unknown>;
		duplicate_of: string | null;
	};
	[AppEvent.OPENING_HOUR_CREATED]: {
		opening_hour_id: string;
	};
	[AppEvent.OPENING_HOUR_DELETED]: {
		opening_hour_id: string;
	};
	[AppEvent.OPENING_HOUR_EXCEPTION_CREATED]: {
		opening_hour_exception_id: string;
	};
	[AppEvent.OPENING_HOUR_EXCEPTION_DELETED]: {
		opening_hour_exception_id: string;
	};
	[AppEvent.OPENING_HOUR_EXCEPTION_UPDATED]: {
		opening_hour_exception_id: string;
	};
	[AppEvent.OPENING_HOUR_UPDATED]: {
		opening_hour_id: string;
	};
	[AppEvent.PACKAGE_CREATED]: {
		package_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PACKAGE_DELETED]: {
		package_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PACKAGE_UPDATED]: {
		package_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PAYMENT_METHOD_UPDATED]: {
		business_id: string;
	};
	[AppEvent.PAYMENT_TRANSACTION_FAILED]: {
		payment_id: string;
	};
	[AppEvent.PAYMENT_TRANSACTION_SUCCESS]: {
		payment_id: string;
	};
	[AppEvent.PRODUCT_CREATED]: {
		product_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PRODUCT_DELETED]: {
		product_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PRODUCT_UPDATED]: {
		product_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PROMO_CODE_CREATED]: {
		promo_code_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PROMO_CODE_DELETED]: {
		promo_code_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.PROMO_CODE_UPDATED]: {
		promo_code_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.QR_CODE_SCANNED]: {
		id: number;
		time: string;
		code: string;
		bookingId: string;
		pax: number;
		business_id: string;
	};
	[AppEvent.SESSION_CREATED]: {
		session_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.SESSION_DELETED]: {
		session_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.SESSION_INSTANCE_CREATED]: {
		session_instance_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.SESSION_INSTANCE_DELETED]: {
		session_instance_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.SESSION_UPDATED]: {
		session_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.SUBSCRIPTION_CANCELED]: {
		business_id: string;
	};
	[AppEvent.SUBSCRIPTION_REACTIVATED]: {
		business_id: string;
	};
	[AppEvent.SUBSCRIPTION_SELECTED]: {
		business_id: string;
		price_id: number;
		package: string;
	};
	[AppEvent.TAG_CREATED]: {
		tag_id: number;
	};
	[AppEvent.TAG_DELETED]: {
		tag_id: number;
	};
	[AppEvent.TEST_EVENT]: {
		result: number;
	};
	[AppEvent.USER_CREATED]: {
		user_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.USER_DELETED]: {
		user_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.USER_DO_NOT_DISTURB_UPDATED]: {
		until: string | null;
	};
	[AppEvent.USER_FORGOTTEN_PASSWORD]: {
		user_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.USER_FORGOTTEN_PASSWORD_RECOVERED]: {
		user_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.USER_PASSWORD_UPDATED]: {
		user_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.USER_UPDATED]: {
		user_id: string;
		changes: Record<string, unknown>;
	};
	[AppEvent.VOUCHER_APPLIED]: {
		business_id: string;
		voucher: string;
	};
};

export type MessageAudience = {
	business_id?: string;
	user_id?: string;
	account_id?: string;
};

export type SocketMessage<E extends AppEvent = AppEvent> = {
	event: E;
	data: AppEventPayloadMap[E];
	audience: MessageAudience;
};